module.exports = __webpack_public_path__ + "media/blackboxSC.148964e6.mp4";